import type { TFunction } from "i18next";

const WINDING_FACTOR = 1.3; // paths aren't straight lines
const WALK_SPEED_MPM = 75; // 4.5 km/h = 75 m/min
const ACCESSIBLE_WALK_SPEED_MPM = 60; // ~3.6 km/h = 60 m/min (wheelchair/stroller)
const MAX_VENUE_DISTANCE = 5000; // 5km — beyond this, not at venue

export function estimateWalkMinutes(distanceMeters: number, speedMpm = WALK_SPEED_MPM): number | null {
  if (distanceMeters > MAX_VENUE_DISTANCE) return null;
  return Math.round((distanceMeters * WINDING_FACTOR) / speedMpm);
}

export function formatWalkTime(distanceMeters: number, accessible = false, t?: TFunction): string | null {
  const speed = accessible ? ACCESSIBLE_WALK_SPEED_MPM : WALK_SPEED_MPM;
  const minutes = estimateWalkMinutes(distanceMeters, speed);
  if (minutes === null) return null;

  if (t) {
    if (minutes < 1) return t("pois:walkTime.lessThan1Min");
    return t("pois:walkTime.estimate", { count: minutes });
  }

  if (minutes < 1) return "< 1 min walk";
  return `~${minutes} min walk`;
}
